import { useCallback, useEffect, useState } from 'react';

import type { StaggerAnimationConfig } from './index';

export const useStaggerAnimation = (
	config: StaggerAnimationConfig = {},
): {
	shouldAnimate: boolean;
	resetAnimation: () => void;
} => {
	const { delay, onStaggeringAnimationTimeout } = config;
	const [shouldAnimate, setShouldAnimate] = useState(false);

	useEffect(() => {
		const timeout = setTimeout(() => {
			setShouldAnimate(true);
			onStaggeringAnimationTimeout?.();
		}, delay);

		return () => clearTimeout(timeout);
	}, [delay, onStaggeringAnimationTimeout]);

	const resetAnimation = useCallback((): void => {
		setShouldAnimate(false);
	}, []);

	return {
		shouldAnimate,
		resetAnimation,
	};
};
